/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, string, bool, func,
} from 'prop-types';
import { withRouter } from 'react-router';
import Button from '@material-ui/core/Button';
import ArrowBack from '@material-ui/icons/ArrowBack';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

class BackButton extends React.Component {
    goToPreviousPage = (url = '') => {
        const { history, location: { pathname } } = this.props;
        if (url) {
            history.push(url);
        } else {
            const paths = pathname.replace(/^\/|\/$/g, '').split('/');
            paths.pop();
            if (paths.length > 0) {
                const prevURL = ''.concat('/', paths.join('/'));
                history.push(prevURL);
            }
        }
    };

    render() {
        const {
            url, desktopButton, desktopHDButton, isROSSUIEnabled, agentButton, clearCallBackState, desktopBackLink, passportBackBtn,
        } = this.props;
        if (isROSSUIEnabled) {
            return (
                <Button
                    className="ROSS-back-button"
                    onClick={() => this.goToPreviousPage(url)}
                >
                    <img src="https://images.contentstack.io/v3/assets/blt95e0138311135214/bltc1774512f33e3b8c/6053dd7d2a6c5a1cccb7a587/back-arrow.svg" alt="back" />
                </Button>
            );
        }
        if (desktopButton) {
            return (
                <Button
                    className="back-link"
                    onClick={() => this.goToPreviousPage(url)}
                >
                    &#60; Back to My Orders
                </Button>
            );
        }
        if (desktopHDButton) {
            return (
                <Button
                    className="secondary"
                    onClick={() => this.goToPreviousPage(url)}
                >
                    <KeyboardArrowLeft /> Back to My Orders
                </Button>
            );
        }
        if (desktopBackLink) { // To have back to order button as a link
            return (
                <Button
                    className="link underline alignCenterLink"
                    onClick={() => this.goToPreviousPage(url)}
                >
                    <KeyboardArrowLeft /> Back to Orders
                </Button>
            );
        }
        if (agentButton) {
            return (
                <>
                    <ArrowBackIosIcon />
                    <Button
                        onClick={() => {
                            this.goToPreviousPage(url);
                            clearCallBackState();
                        }}
                        className="agentBackBtn"
                    >

                        Back to agent login
                    </Button>
                </>
            );
        }

        if (passportBackBtn) {
            return (
                <>
                    <Button
                        className="back-arrow-button"
                        onClick={() => this.goToPreviousPage(url)}
                    >
                        <ArrowBack /> Back
                    </Button>
                </>
            );
        }
        return (
            <Button
                className="back-arrow-button"
                onClick={() => this.goToPreviousPage(url)}
            >
                <ArrowBack />
            </Button>
        );
    }
}

BackButton.defaultProps = {
    url: '',
    desktopButton: false,
    desktopHDButton: false,
    isROSSUIEnabled: false,
    agentButton: false,
    desktopBackLink: false,
    passportBackBtn: false,
};

BackButton.propTypes = {
    history: object.isRequired,
    location: object.isRequired,
    clearCallBackState: func.isRequired,
    url: string,
    desktopButton: bool,
    desktopHDButton: bool,
    isROSSUIEnabled: bool,
    agentButton: bool,
    desktopBackLink: bool,
    passportBackBtn: bool,
};

export default withRouter(BackButton);
